module.exports = __webpack_public_path__ + "img/section5Logo2.0187e65c.svg";